import React from 'react';
import SingleListLeadsDetails from '../components/atoms/LeadsDetails/SingleListLeadsDetails';

const SingleListLead = () => {
  return <SingleListLeadsDetails />;
};

export default SingleListLead;
